import translations from '../../components/location/ts/de-DE';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('de-DE', translations);
